import { render, staticRenderFns } from "./ConfigSimulacion.vue?vue&type=template&id=21d2d408&scoped=true&"
import script from "./ConfigSimulacion.vue?vue&type=script&lang=js&"
export * from "./ConfigSimulacion.vue?vue&type=script&lang=js&"
import style0 from "./ConfigSimulacion.vue?vue&type=style&index=0&id=21d2d408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d2d408",
  null
  
)

export default component.exports